<template>
  <div>
    <titulo-contas-pagar @cadastrar="openModal" />

    <filtro
      class="mb-3"
      :filtroAntigo="filtroAntigo"
      @filtrar="parametroFiltro"
      @gerar-contas="gerarContas"
      @gerar-extrato="abrirModalImprimirExtrato"
      @baixar-titulo="redirecionaBaixarTitulo"
      :disabled="items.length === 0"
    />

    <tabela-contas-pagar
      :items="items"
      @atualiza-tabela="listarContasPagar"
      @baixa-titulo="redirecionaBaixarTitulo"
      @ajustar-titulo="openModal"
      @alterar-ordenacao="novaOrdenacao"
    />

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="listarContasPagar"
    />

    <modal-contas-pagar
      :exibir="modais.contasPagar"
      :form="modais.contasPagarDados"
      @fechar="closeModal('contasPagar')"
      @atualiza-listagem="listarContasPagar"
    />

    <modal-baixa-titulo
      :exibir="modais.baixaTitulo"
      :form="modais.baixaTituloDados"
      @atualiza-tabela="listarContasPagar"
      @fechar="closeModal('baixaTitulo')"
    />

    <modal-ajustar-titulo
      :exibir="modais.ajustarTitulo"
      :form="modais.ajustarTituloDados"
      @atualiza-tabela="listarContasPagar"
      @fechar="closeModal('ajustarTitulo')"
    />

    <modal
      id="modalSuprimentoFiltroProduto"
      titulo="Ordenar por:"
      :exibir="mostrarModalOrdenacaoExtrato"
      tamanho="sm"
      @fechar="() => mostrarModalOrdenacaoExtrato = false"
    >
      <div class="d-flex justify-content-between w-100 mt-3">
        <b-button  variant="primary" @click="gerarExtrato(true)">
          Data de Vencimento
        </b-button>
        <b-button
          class=" ml-2"
          variant="success"
          @click="gerarExtrato(false)"
        >
          Data de Pagamento
        </b-button>
      </div>

      <template #modal-footer>
        <div />
      </template>
    </modal>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
import pdf from '@/common/utils/pdf';
import Modal from '@/components/modal/Modal';

// Services:
import TituloService from '@/common/services/titulo/titulo.service';

// Components:
import Filtro from './components/filtro/Index';
import TabelaContasPagar from './components/Tabela';
import Paginacao from '@/components/paginacao/Paginacao';
import {
  ModalBaixaTitulo,
  ModalContasPagar,
  ModalAjustarTitulo,
} from './components/modais/index';
import TituloContasPagar from '@/views/financeiro/lancamentos/contas-pagar/components/TituloContasPagar.vue';

export default {
  components: {
    TituloContasPagar,
    Filtro,
    TabelaContasPagar,
    Paginacao,
    ModalBaixaTitulo,
    ModalContasPagar,
    ModalAjustarTitulo,
    Modal,
  },
  data() {
    return {
      items: [],
      filtroSelecionado: {},
      filtroAntigo: {},
      modais: {
        contasPagar: false,
        contasPagarDados: {},
        baixaTitulo: false,
        baixaTituloDados: {},
        ajustarTitulo: false,
        ajustarTituloDados: {},
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: 'Fornecedor',
      ordem: true,
      mostrarModalOrdenacaoExtrato: false,
      filtroOrdenacaoTemp: false,
    };
  },
  mounted() {
    // if (localStorage.getItem('filtroContasPagar')) {
    //   this.parametroFiltro(
    //     JSON.parse(localStorage.getItem('filtroContasPagar'))
    //   );
    //   this.filtroAntigo = JSON.parse(localStorage.getItem('filtroContasPagar'));
    // }
  },
  methods: {
    abrirModalImprimirExtrato(filtro) {
      this.mostrarModalOrdenacaoExtrato = true;
      this.filtroOrdenacaoTemp = filtro;
    },
    redirecionaBaixarTitulo(id) {
      this.$router.push({
        name: 'financeiro-contas-pagar-baixar-titulo',
        params: { id },
      });

      // localStorage.setItem(
      //   'filtroContasPagar',
      //   JSON.stringify(this.filtroSelecionado)
      // );
    },
    // FUNÇÕES FILTRO:
    parametroFiltro(filtro) {
      this.filtroSelecionado = filtro;
      this.listarContasPagar();
    },

    listarContasPagar() {
      this.$store.dispatch(START_LOADING);
      TituloService.filtrarContaPagarPaginado(this.filtroSelecionado, this.paginacao, this.campoOrdenado, this.ordem)
        .then((data) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES TABELA:
    atualizarTabela() {
      this.refiltrar == false
        ? (this.refiltrar = true)
        : (this.refiltrar = false);
    },

    // RELATORIOS:
    gerarContas() {
      this.$store.dispatch(START_LOADING);
      TituloService.gerarRelatorioContasPrevistas(this.filtroSelecionado)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    gerarExtrato(ordenarPorData) {
      this.$store.dispatch(START_LOADING);
      TituloService.gerarRelatorioExtrato(this.filtroOrdenacaoTemp, ordenarPorData)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.filtroOrdenacaoTemp = false;
          this.mostrarModalOrdenacaoExtrato = false;
        });
    },
    // FUNÇÕES MODAL:
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.listarContasPagar(); 
    },
  },
};
</script>
